import { useState, useEffect } from "react";
import { Toolbar, Stack, Typography, Link, Divider } from "@mui/material";
import { useData } from "../hooks/useData";
import Logo from "./Logo";
import PhoneIcon from "@mui/icons-material/Phone";
import ViewCart from "./ViewCart";
import FileMenu from "./FileMenu";
import EditMenu from "./EditMenu";
import ToolsMenu from "./ToolsMenu";

const TopToolbar = () => {
  const { canvas } = useData();

  return (
    <Toolbar
      sx={{
        minHeight: { xs: 40, sm: 48 },
        backgroundColor: "white",
        justifyContent: "space-between",
        py: 0, // Remove padding to match exact height
      }}
    >
      <Stack direction="row" spacing={3} sx={{ alignItems: "center", ml: 4 }}>
        <Logo />
        <Divider orientation="vertical" variant="middle" flexItem />
        <FileMenu canvas={canvas} />
        <EditMenu canvas={canvas} />
        <ToolsMenu canvas={canvas} />
      </Stack>
      <Stack direction="row" spacing={3} sx={{ alignItems: "center", mr: 4 }}>
        <Link href="tel:8005826366" underline="none">
          <PhoneIcon sx={{ color: "#c82027" }} />
          <Typography
            sx={{
              display: "inline-block",
              fontFamily: "Roboto",
              fontSize: "1rem",
              color: "black",
              fontWeight: 500,
              ml: 1,
            }}
          >
            800-582-6366
          </Typography>
        </Link>
        <Divider
          orientation="vertical"
          variant="middle"
          sx={{ mr: 2, ml: 2 }}
          flexItem
        />
        <ViewCart />
      </Stack>
    </Toolbar>
  );
};

export default TopToolbar;
